// index.jsxx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";


const cognitoAuthConfig = {
  authority: "https://cognito-idp.eu-north-1.amazonaws.com/eu-north-1_HTT4UQ7Xc",
  client_id: "41vjsqnlqsalec316ga7hdjn76",
  redirect_uri: window.location.origin,
  //redirect_uri: "https://d2aesn939lwjhj.cloudfront.net",
  response_type: "code",
  scope: "email openid phone aws.cognito.signin.user.admin",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
